





























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Column, ColumnType, EventDetail } from '@/api/model/DefaultPageEntity'
import { UtilsIndex } from '@/utils'

@Component
export default class DefaultColumnItem extends Vue {
    name = 'default-column-item'
    @Prop({ default: () => ({}) })
    column!: Column
    columnType = ColumnType
    UtilsIndex = UtilsIndex

    @Emit('onColumnEvent')
    onColumnEvent(detail: any): EventDetail {
        return { data: detail.scope.row, ...detail.event, column: detail.column }
    }

    isEventVisible(item, row) {
        if (typeof item.show === 'function') {
            return item.show(row)
        }
        return item.show !== false
    }
}
